/*
 * Keeps the free delivery strip at the top of the cart drawer current
 * (snippets/b22-free-delivery-bar.liquid, #CartDrawerDeliveryBar in sections/cart-drawer.liquid).
 *
 * The drawer redraws in several ways (Add to basket, quantity changes, the Add Extras "+",
 * cart.js onCartUpdate swapping the whole cart-items element), and every one of them brings a
 * fresh cart-items section. That section carries the bar for the new basket in a
 * <template class="js-b22-delivery-bar-src">, so watching the drawer and copying the newest one
 * into the strip covers them all without adding to the sections each request asks for.
 */
(function () {
  function sync() {
    var drawer = document.getElementById('cart-drawer');
    var strip = document.getElementById('CartDrawerDeliveryBar');
    if (!drawer || !strip) return;
    var sources = drawer.querySelectorAll('.js-b22-delivery-bar-src');
    if (!sources.length) return;
    strip.innerHTML = sources[sources.length - 1].innerHTML;
    sources.forEach(function (source) {
      source.remove();
    });
  }

  function init() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    sync();
    new MutationObserver(sync).observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
